import { render, staticRenderFns } from "./setTransfer.vue?vue&type=template&id=4284fb66&scoped=true&"
import script from "./setTransfer.vue?vue&type=script&lang=js&"
export * from "./setTransfer.vue?vue&type=script&lang=js&"
import style0 from "./setTransfer.vue?vue&type=style&index=0&id=4284fb66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284fb66",
  null
  
)

export default component.exports